import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ServerDashboardJob } from '../../dashboardType';

const formatFileSize = (bytes?: number): string => {
  if (bytes === undefined || bytes === null) {
    return '';
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  }
  if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
  if (bytes < 1024 * 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
  return `${(bytes / (1024 * 1024 * 1024 * 1024)).toFixed(2)} TB`;
};

const FileSizeCell = (
  properties: CustomCellRendererProps<ServerDashboardJob>
) => {
  const fileSize = properties.data?.fileSize;

  if (fileSize === undefined || fileSize === null) {
    return null;
  }

  return <span>{formatFileSize(fileSize)}</span>;
};

export default FileSizeCell;

